import React, { useState, useEffect } from 'react';
import { apsisService } from '../services/apsisService';
import { supabase } from '../supabaseClient';
import './APSISSection.css';

function APSISSection({ edition: customEdition }) {
  const [settings, setSettings] = useState(null);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [formData, setFormData] = useState({
    society: '',
    domaine: '',
    contact_email: '',
    phone_number: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);

  useEffect(() => {
    loadSettings();
  }, [customEdition]);

  const loadSettings = async () => {
    try {
      setLoading(true);
      let editionYear = customEdition;
      if (!editionYear) {
        const { data: activeEdition } = await supabase
          .from('editions')
          .select('year')
          .eq('is_active', true)
          .single();
        editionYear = activeEdition?.year || '2025';
      }

      const data = await apsisService.getSettings(editionYear);
      setSettings(data);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      setSubmitting(true);
      await apsisService.register({
        ...formData,
        edition_id: settings.edition_id
      });
      setSubmitted(true);
      setFormData({ society: '', domaine: '', contact_email: '', phone_number: '' });
      setTimeout(() => {
        setSubmitted(false);
        setShowForm(false);
      }, 3000);
    } catch (error) {
      console.error('Error submitting form:', error);
      alert('Une erreur est survenue lors de l\'inscription.');
    } finally {
      setSubmitting(false);
    }
  };

  if (loading || !settings || !settings.is_visible) return null;

  return (
    <div className="apsis-section">
      <div className="apsis-container">
        <h2 className="apsis-title">{settings.title}</h2>


        <h3 className="apsis-date">DU 02 AU 06 NOVEMBRE 2026</h3>
        
        {settings.footer_image_url && (
          <div className="apsis-footer-image">
            <div className="footer-image-wrapper">
              <a href={settings.footer_pdf_url || '#'} target="_blank" rel="noopener noreferrer">
                <img src={settings.footer_image_url} alt="APSIS Detail" className="footer-img" />
              </a>
            </div>
          </div>
        )}

        <div className="apsis-actions">
          <button 
            className="inscrire-btn"
            onClick={() => setShowForm(!showForm)}
          >
            S'inscrire
          </button>
        </div>

        {showForm && (
          <div className="apsis-form-container">
            {submitted ? (
              <div className="success-message">
                <h3>Merci pour votre inscription !</h3>
                <p>Nous vous contacterons prochainement.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="apsis-registration-form">
                <div className="form-grid">
                  <div className="form-group">
                    <label>Société / Organisme</label>
                    <input
                      type="text"
                      name="society"
                      value={formData.society}
                      onChange={handleInputChange}
                      required
                      placeholder="Votre société"
                    />
                  </div>
                  <div className="form-group">
                    <label>Domaine d'activité</label>
                    <input
                      type="text"
                      name="domaine"
                      value={formData.domaine}
                      onChange={handleInputChange}
                      required
                      placeholder="Ex: Sécurité, IT, etc."
                    />
                  </div>
                  <div className="form-group">
                    <label>Email de contact</label>
                    <input
                      type="email"
                      name="contact_email"
                      value={formData.contact_email}
                      onChange={handleInputChange}
                      required
                      placeholder="exemple@domaine.com"
                    />
                  </div>
                  <div className="form-group">
                    <label>Numéro de téléphone</label>
                    <input
                      type="tel"
                      name="phone_number"
                      value={formData.phone_number}
                      onChange={handleInputChange}
                      required
                      placeholder="+212 ..."
                    />
                  </div>
                </div>
                <button type="submit" className="submit-btn" disabled={submitting}>
                  {submitting ? 'Envoi en cours...' : 'Envoyer l\'inscription'}
                </button>
              </form>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default APSISSection;
